import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useAppDispatch, useAppSelector } from "../../useStore";
import swal from 'sweetalert';
import { reset, ResignApplicant, } from "../../features/Applicant/applicantSlice";
import { Spinners } from "../TableOptions";
import ModalHeader from "../ModalHeader";
import moment from "moment";
import FormControl from '@mui/material/FormControl';
import { TextField } from "@mui/material";

const ResignedModal = ({ title, id, name }) => {
  const { ResignApplicantisSuccess, ResignApplicantisError, ResignApplicantisLoading, ResignApplicantmessage } = useAppSelector((state: any) => state.applicant);
  const dispatch = useAppDispatch();

  const [welcome, setWelcome] = useState(false);
  const handleCloseWelcome = () => setWelcome(false);
  const handleWelcome = () => setWelcome(true);
  const [inputs, setInputs] = useState({
    resignedDate: "",
    applicationIds: "",
  });

  useEffect(() => {
    setInputs((prevState: any) => {
      return {
        ...prevState,
        resignedDate: moment(inputs.resignedDate).format('DD/MM/YYYY'),
        applicationIds: [id],
      };
    });
  }, [setInputs, id]);








  useEffect(() => {
    if (ResignApplicantisError) {
      swal({
        title: "error",
        text: ResignApplicantmessage,
        icon: "error"
      })
      dispatch(reset())
    } else if (ResignApplicantisSuccess) {
      setInputs({
        resignedDate: "",
        applicationIds: "",
      })
      swal({
        title: "success",
        text: "Applicant have been resigned!",
        icon: "success"
      })
      setWelcome(false)
      dispatch(reset())
    }

  }, [dispatch,
    ResignApplicantisError,
    ResignApplicantisSuccess,
    ResignApplicantmessage])


  const handleUpdate = () => {
    // @ts-ignore
    dispatch(ResignApplicant(inputs));
  };


  const handleOnChange = (input: any, value: any) => {
    setInputs((prevState: any) => ({
      ...prevState,
      [input]: value,
    }));
  };


  return (
    <div>
      <div onClick={handleWelcome} className="more-button">
        {title}
      </div>

      <Modal show={welcome} onHide={handleCloseWelcome} centered>
        <ModalHeader setShow={setWelcome} headerTitle={"Resign"} />
        <Modal.Body>
          <form>
            <div className="applicant-details">
              <h5>Are you sure you want to resign?</h5>
              <p className="applicant-name">
                <strong> </strong> {name}
              </p>
            </div>
            <div className='schedule-setting mt-3'>


              <FormControl fullWidth>
                <h5>Resigned Date</h5>
                <TextField
                  required
                  id="outlined-basic"
                  name='date'
                  type='date'
                  size="small"
                  style={{ width: "100%", margin: "10px 0" }}
                  variant="outlined"
                  value={inputs.resignedDate}
                  onChange={(e) => handleOnChange("resignedDate", e.target.value)} />
              </FormControl>

            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseWelcome}>
            Cancel
          </Button>
          <Button id="primary" onClick={handleUpdate}>
            {ResignApplicantisLoading ? <Spinners size={"sm"} /> : 'Yes'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ResignedModal;
